import React, { FC } from 'react'

import { IconCareersProps } from './IconCareers.types'
import * as Styled from './styles/IconCareers.style'

import { nonThemeableRules } from '../../ruleSet'

const IconCareers: FC<IconCareersProps> = ({
  size = nonThemeableRules.defaultSize as number as IconCareersProps['size'],
  isResponsive = false,
  appearance = 'primary',
  inverse = false,
  state,
}: IconCareersProps) => {
  return (
    <Styled.IconWrapper size={size} isResponsive={isResponsive} appearance={appearance} inverse={inverse} state={state}>
      <svg viewBox='0 0 160 160' xmlns='http://www.w3.org/2000/svg'>
        <path d='M144 32h-32v-6.79C112 14.76 105.79 8 96.17 8H63.64C54.14 8 48 14.71 48 25.09V32H16A16 16 0 0 0 0 48v96a16 16 0 0 0 16 16h128a16 16 0 0 0 16-16V48a16 16 0 0 0-16-16zm-88-6.91c0-4.15 1.33-9.09 7.64-9.09h32.53c6.83 0 7.83 5.77 7.83 9.21V32H56zM16 40h128a8 8 0 0 1 8 8v15.47l-63.17 8a75 75 0 0 1-17.63 0l-63.2-8V48a8 8 0 0 1 8-8zm128 112H16a8 8 0 0 1-8-8V71.54l62.23 7.87A82.94 82.94 0 0 0 80 80a83.3 83.3 0 0 0 9.81-.58L152 71.54V144a8 8 0 0 1-8 8z' />
        <circle cx='80' cy='96' r='8' />
      </svg>
    </Styled.IconWrapper>
  )
}

export default IconCareers
